import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import TeamActivityPage from "@/components/team-activity/team-activity-page";
import { userIdSearchSchema } from "@/lib/search/user-id-search";

const TeamActivityRoutePage = (): JSX.Element => {
	const { userId } = Route.useSearch();
	return <TeamActivityPage userId={userId} />;
};

export const Route = createFileRoute("/_app/team-activity/")({
	validateSearch: userIdSearchSchema,
	component: TeamActivityRoutePage,
});
